<ng-container *ngFor="let alert of alerts">
  <div class="full-width-border"></div>
  <div class="alert-row" [ngClass]="'alert-row--' + alert.status">
    <i class="fa alert-icon" [ngClass]="getIconClass(alert.name)" aria-hidden="true"></i>
    <div class="alert-text">
      <div *ngFor="let line of splitDescription(alert.description)">{{ line }}</div>
    </div>
  </div>
</ng-container>
